import { useEffect, useState } from 'react';
import { Button, Group, PasswordInput } from '@mantine/core';
import { IUser, IUserUpdate, updateUser } from '../../../libraries/user';
import CustomModal from '../../components/custom-modal';
import ModalComponent from '../../components/modal';
import { Language } from '../../languages/languageHandler';
import './styles.scss';

const UpdateUserConfirmation: React.FC<{
  userData: Partial<IUser>;
  lang: Language;
  toggleModal: () => void;
  openModal: boolean;
  onSubmit: (data?: any) => void;
}> = ({ userData, lang, toggleModal, openModal }) => {
  const [currentPassword, setCurrentPassword] = useState<string>('');
  const [showSuccessDialog, setShowSuccessDialog] = useState<boolean>(false);
  const [showErrorDialog, setShowErrorDialog] = useState<boolean>(false);
  const [successMessage, setSuccessMessage] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>('');

  useEffect(() => {
    if (!openModal) {
      setCurrentPassword('');
    }
  }, [openModal]);

  const submitForm = async (formValues: any) => {
    const request: IUserUpdate = {
      user: {
        ...userData,
        ...formValues
      },
      currentPassword
    };

    const controller = new AbortController();

    try {
      const response = await updateUser(request, controller);
      if (response.statusOper && response.statusOper.code !== 0) {
        setErrorMessage(
          `${lang.USER_UPDATE_ERROR} (Code: ${response.statusOper.code}) ${response.statusOper.message || 'An unknown error occurred.'}`
        );
        setShowErrorDialog(true);

        setTimeout(() => {
          setShowErrorDialog(false);
        }, 2000);
      } else {
        setSuccessMessage(lang.EDIT_USER_ALERT_UPDATE_SUCCESS || 'User updated successfully');
        setShowSuccessDialog(true);

        setTimeout(() => {
          setShowSuccessDialog(false);
          toggleModal();
        }, 2000);
      }
    } catch (error) {
      console.error('Error during the API call:', error);
      setErrorMessage(`${lang.EDIT_USER_ALERT_UPDATE_ERROR} (Status: ${errorMessage})`);
      setShowErrorDialog(true);

      setTimeout(() => {
        setShowSuccessDialog(false);
        handleClose();
      }, 2000);
    }
  };

  const handleClose = () => {
    setCurrentPassword('');
    toggleModal();
  };

  return (
    <>
      {/* Modal for updating user */}
      <ModalComponent
        show={openModal}
        handleClick={handleClose}
        title={lang.USER_CONFIRM_PASSWORD}
        content={
          <form
            onSubmit={e => {
              e.preventDefault();
              submitForm({});
            }}
          >
            <Group classNames={{ root: 'update-confirmation' }}>
              <PasswordInput
                label={lang.USER_CONFIRM_CURRENT_PASSWORD}
                value={currentPassword}
                onChange={event => setCurrentPassword(event.target.value)}
                type="password"
              />
            </Group>
            <Group>
              <Button type="submit" color="#016273" radius="md">
                {lang.GLOBAL_SAVE_BUTTON}
              </Button>
              <Button color="#016273" radius="md" onClick={handleClose}>
                {lang.GLOBAL_CANCEL}
              </Button>
            </Group>
          </form>
        }
      />

      <CustomModal
        opened={showSuccessDialog}
        onClose={() => setShowSuccessDialog(false)}
        message={successMessage}
        backgroundColor="#3BDF70"
        textColor="black"
      />

      <CustomModal
        opened={showErrorDialog}
        onClose={() => setShowErrorDialog(false)}
        message={errorMessage}
        backgroundColor="#E3353F"
        textColor="white"
      />
    </>
  );
};

export default UpdateUserConfirmation;
